import * as React from 'react';
import { SelectionToggleEnabledIcon, SelectionToggleDisabledIcon } from '../../icons';
import './SelectionToggle.less';

interface Props {
    enabled: boolean;
    onChange: (enabled: boolean) => void;
}

const SelectionToggle: React.FC<Props> = ({ enabled, onChange }) => {
    return (
        <div className={`selection-toggle ${enabled ? 'enabled' : 'disabled'}`} onClick={() => onChange(!enabled)}>
            {enabled ? <SelectionToggleEnabledIcon /> : <SelectionToggleDisabledIcon />}
        </div>
    );
};

export default SelectionToggle;
